module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Laptop-b9542be8ba43521c55244ee9ed836440.svg";